import { useMutation, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, ProgressBar, Row } from "react-bootstrap";
import { useHistory, useRouteMatch } from "react-router-dom";
import {
  GET_PROJECT_SUPERVISOR,
  GET_TASK_SUPERVISOR,
} from "../../../graphql/queries";

import {
  UPDATE_STATUS_PROJECT_RETURN_PLANNER,
  UPDATE_STATUS_PROJECT_SUPERVISOR,
} from "../../../graphql/mutation";
import moment from "moment";
import { LinearProgress } from "@material-ui/core";
import "moment/locale/id";
import { useFormik } from "formik";
import { connect } from "react-redux";
import { matchProjectID } from "../../../redux/actions/spvAction";
import SEO from "../../SEO";
import Swal from "sweetalert2";
moment.locale("id");

const ProjectDetail = ({ createNewNote, matchProjectID, projectID }) => {
  let workerList = [];
  const history = useHistory();
  const match = useRouteMatch();

  console.log(match.params.id);

  useEffect(() => {
    matchProjectID(match.params.id);
    console.log(projectID);
  }, []);

  const formik = useFormik({
    initialValues: createNewNote,
    onSubmit: async (values) => {
      console.log(values);
      const returnToPlanner = await updateStatusProjectReturnNotePlanner({
        variables: {
          ...values,
          id: parseInt(match.params.id),
        },
      });
      const updateStatusReturn = await updateStatusProject({
        variables: { id: parseInt(match.params.id), status: "return" },
      });

      let timerInterval;
      const alertToUser = await Swal.fire({
        title: "Success!",
        text: "The project has been successfully returned to planner",
        timer: 3000,
        icon: "success",
        timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
        },
        willClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          console.log("I was closed by the timer");
        }
      });
      const pushToProjectList = await history.push(
        "/dashboard/supervisor/project-list"
      );

      returnToPlanner();
      updateStatusReturn();
      alertToUser();
      pushToProjectList();
    },
  });

  const convertToDate = (inputDate) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    let date = new Date(+inputDate);
    return date.toLocaleDateString("id-ID", options);
  };

  const {
    error: projectError,
    data: projectData,
    loading: projectLoading,
  } = useQuery(GET_PROJECT_SUPERVISOR, {
    pollInterval: 1000,
  });

  const { error: taskError, data: taskData, loading: taskLoading } = useQuery(
    GET_TASK_SUPERVISOR,
    {
      pollInterval: 1000,
    }
  );
  const [updateStatusProject] = useMutation(UPDATE_STATUS_PROJECT_SUPERVISOR);
  const [updateStatusProjectReturnNotePlanner] = useMutation(
    UPDATE_STATUS_PROJECT_RETURN_PLANNER
  );

  // const [returnWithNote] = useMutation(CREATE_NOTE_SUPERVISOR);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (projectLoading) return <LinearProgress />;
  if (projectError) return "Error...";

  if (taskLoading) return <LinearProgress />;
  if (taskError) return "Error...";

  const filterProjectData = projectData.findAllProjectSupervisor.filter(
    (item) => item.id == match.params.id
  );

  const filterTaskData = taskData.findAllTaskSupervisor.filter(
    (item) => item.project_id == match.params.id
  );

  const getTaskDetail = filterTaskData
    .slice()
    .sort(({ id: previousID }, { id: currentID }) => previousID - currentID)
    .map(({ id, task, is_check }, key) => {
      return (
        <div className="detail-project-border my-3" key={key}>
          <p className="text-capitalize m-0">
            {key + 1}. {task}
          </p>
        </div>
      );
    });

  const modalNotes = filterProjectData.map(({ id, title, description }) => {
    return (
      <>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          key={id}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-center">
              {/* <strong>Project Title: </strong> {title} */}
              {title}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={formik.handleSubmit}>
              <p className="font-weight-bold">Project ID: {projectID}</p>
              <input
                type="text"
                placeholder={projectID}
                name="project_id"
                value={formik.values.project_id}
                onChange={formik.handleChange}
                style={{ width: "50px" }}
                className="text-center mb-3"
                hidden
                disabled
              />
              <p className="font-weight-bold">Project Description: </p>
              <p>{description}</p>

              <p className="font-weight-bold">Notes for Planner: </p>
              <textarea
                type="text"
                name="note"
                value={formik.values.note}
                placeholder="Insert a new note here"
                onChange={formik.handleChange}
                style={{ width: "100%", resize: "none", height: "200px" }}
              />
              <div className="d-flex justify-content-end">
                <Button title="Close" variant="secondary" onClick={handleClose}>
                  Close
                </Button>
                <Button className="ml-3" type="submit">
                  Submit
                </Button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </>
    );
  });

  filterProjectData[0].worker.map(({ fullname }) => {
    return workerList.push(fullname);
  });

  const getNotes = filterProjectData[0].notes.map(({ note }, key) => {
    return (
      <>
        <li className="list-group-item" key={key}>
          - {note}
        </li>
      </>
    );
  });

  // console.log(filterProjectData[0])

  const getProjectData = filterProjectData.map(
    ({
      id,
      created_by: { fullname },
      title,
      description,
      status,
      assignee,
      attachment,
      is_read,
      start_date,
      due_date,
      notes,
    }) => {
      return (
        <div key={id} className="tasklist-progress pb-5 border-primary">
          <Row className="d-flex justify-content-center text-center">
            <Col lg={2} sm={6}>
              <p>
                <strong>Start Date</strong>
                <br />
                {convertToDate(start_date)}
              </p>
            </Col>
            <Col lg={2} sm={6}>
              <p>
                <strong>End Date</strong>
                <br />
                {convertToDate(due_date)}
              </p>
            </Col>
            <Col lg={2} sm={6}>
              <p className="text-capitalize">
                <strong>Planner Name</strong> <br />
                {fullname}
              </p>
            </Col>
            <Col lg={2} sm={6}>
              <p className="text-capitalize">
                <strong>Worker Name</strong> <br />
                <span>{workerList.join(", ")}</span>
              </p>
            </Col>
            <Col lg={2} sm={6}>
              <p
                className={`text-capitalize ${
                  status === "approve"
                    ? "bg-success text-white text-center"
                    : status === "reject"
                    ? "bg-danger text-white text-center"
                    : status === "submit"
                    ? "bg-primary text-white text-center"
                    : "bg-warning text-white text-center"
                }`}
              >
                Status: <br />
                {status}
              </p>
            </Col>
          </Row>
          <div className="mt-3">
            <h3 className="text-center font-weight-bold mb-3">{title}</h3>
            <p>
              <strong>Project ID:</strong> {id}
            </p>
            <p>
              <strong>Description</strong>
              <br />
              {description}
            </p>

            <p>
              <strong>File Attachment: </strong>
              {attachment ? (
                <a href={attachment} download>
                  Link Attachment
                </a>
              ) : (
                "None"
              )}
            </p>

            <div>
              <p className="font-weight-bold my-3">
                Task List{" "}
                <span
                  className={`font-weight-normal ${
                    getTaskDetail ? "" : "d-none"
                  }`}
                >
                  {getTaskDetail ? "" : "None"}
                </span>
              </p>
              {getTaskDetail}
            </div>

            <ul className="list-group">
              <span>
                <strong>Notes</strong>
                {!notes[0] ? ": None" : ""}
              </span>
              {notes[0] ? getNotes : ""}
            </ul>
          </div>
          <div className="d-flex justify-content-end align-items-end my-3">
            <Row>
              <Col xs={12}>
                {status === "approve" || status === "reject" ? (
                  ""
                ) : (
                  <>
                    <Button
                      variant="warning"
                      onClick={handleShow}
                      className="mx-2 text-white"
                    >
                      Return To Planner
                    </Button>

                    <Button
                      variant="danger"
                      className="mx-2"
                      onClick={() => {
                        const updateStatusReject = async () =>
                          await updateStatusProject({
                            variables: { id: id, status: "reject" },
                          });

                        let timerInterval;
                        const alertToUser = async () =>
                          await Swal.fire({
                            title: "Success!",
                            text: "The project has been successfully rejected",
                            timer: 3000,
                            icon: "success",
                            timerProgressBar: true,
                            didOpen: () => {
                              Swal.showLoading();
                            },
                            willClose: () => {
                              clearInterval(timerInterval);
                            },
                          }).then((result) => {
                            /* Read more about handling dismissals below */
                            if (result.dismiss === Swal.DismissReason.timer) {
                              console.log("I was closed by the timer");
                            }
                          });
                        const pushToProjectList = async () =>
                          await history.push(
                            "/dashboard/supervisor/project-list"
                          );
                        updateStatusReject();
                        alertToUser();
                        pushToProjectList();
                      }}
                    >
                      Reject
                    </Button>
                    <Button
                      className="mx-2"
                      onClick={() => {
                        const updateStatusApprove = async () =>
                          await updateStatusProject({
                            variables: { id: id, status: "approve" },
                          });

                        let timerInterval;
                        const alertToUser = async () =>
                          await Swal.fire({
                            title: "Success!",
                            text: "The project has been successfully approved",
                            timer: 3000,
                            icon: "success",
                            timerProgressBar: true,
                            didOpen: () => {
                              Swal.showLoading();
                            },
                            willClose: () => {
                              clearInterval(timerInterval);
                            },
                          }).then((result) => {
                            /* Read more about handling dismissals below */
                            if (result.dismiss === Swal.DismissReason.timer) {
                              console.log("I was closed by the timer");
                            }
                          });
                        const pushToProjectList = async () =>
                          await history.push(
                            "/dashboard/supervisor/project-list"
                          );
                        updateStatusApprove();
                        alertToUser();
                        pushToProjectList();
                      }}
                    >
                      Approve
                    </Button>
                  </>
                )}
              </Col>
            </Row>
          </div>
        </div>
      );
    }
  );
  return (
    <div className="project-list-section m-2 pb-5">
      <SEO
        title="Supervisor"
        description="Project List"
        content="Project List"
      />

      {modalNotes}
      <Button
        variant="primary"
        onClick={() => history.push("/dashboard/supervisor/project-list")}
      >
        Back
      </Button>
      <h1 className="text-center text-primary my-5">Detail Project</h1>
      <Row>
        <Col lg={10} md={10} sm={10} xs={10} className="mx-auto">
          {getProjectData}
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    createNewNote: state.spv.createNewNote,
    projectID: state.spv.matchProjectID,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    matchProjectID: (projectID) => dispatch(matchProjectID(projectID)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetail);
